import styled from 'styled-components'
import { Flex } from 'components/common/styles'
import { StyledSelectInput } from 'components/common/Inputs/styles'

export const SiteAndUnitsWrapper = styled.div`
  padding: 6px 0 0 24px;

  .MuiIconButton-root.Mui-disabled {
    svg {
      opacity: 0.5;
    }
  }

  > div {
    ${StyledSelectInput} {
      margin: 0;
      .MuiFormControl-root {
        max-width: 176px;
        width: 176px;
      }
    }
  }
`

export const RowContainer = styled(Flex)`
  padding-bottom: 12px;

  &:last-child {
    padding: 0;
  }
`

export const SelectContainer = styled.div`
  padding: 0 10px;
`
